"use client";

import {
  BORDER,
  FONT_MONO,
  GOLD,
  GREEN,
  TEXT,
  TEXT_MUTE,
  VIOLET_BRIGHT,
} from "./palette";

type Props = {
  combo: number;
  bestCombo: number;
  hits: number;
  misses: number;
};

export function ChordPracticeTempoStats({
  combo,
  bestCombo,
  hits,
  misses,
}: Props) {
  const total = hits + misses;
  const accuracy = total === 0 ? 0 : Math.round((hits / total) * 100);

  let comboAccent = TEXT;
  if (combo >= 5) {
    comboAccent = GOLD;
  } else if (combo >= 3) {
    comboAccent = VIOLET_BRIGHT;
  }

  let accuracyAccent = TEXT;
  if (accuracy >= 90) {
    accuracyAccent = GREEN;
  } else if (accuracy >= 70) {
    accuracyAccent = VIOLET_BRIGHT;
  }

  return (
    <section
      className="relative z-10 grid shrink-0"
      style={{
        padding: "14px 24px",
        borderBottom: `1px solid ${BORDER}`,
        background: "rgba(10, 10, 14, 0.6)",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        gap: 16,
      }}
    >
      <Stat
        label="COMBO"
        value={String(combo)}
        accent={comboAccent}
        suffix={combo >= 3 ? "🔥" : ""}
      />
      <Stat
        label="MEILLEURE SÉRIE"
        value={String(bestCombo)}
        accent={VIOLET_BRIGHT}
        border
      />
      <Stat
        label="PRÉCISION"
        value={`${accuracy}%`}
        accent={accuracyAccent}
        border
      />
      <Stat label="MESURES" value={String(total)} accent={TEXT} border />
    </section>
  );
}

type StatProps = {
  label: string;
  value: string;
  suffix?: string;
  accent?: string;
  border?: boolean;
};

function Stat({
  label,
  value,
  suffix = "",
  accent = TEXT,
  border = false,
}: StatProps) {
  return (
    <div
      style={{
        paddingLeft: border ? 16 : 0,
        borderLeft: border ? `1px solid ${BORDER}` : "none",
      }}
    >
      <div
        style={{
          fontSize: 9,
          fontFamily: FONT_MONO,
          color: TEXT_MUTE,
          letterSpacing: "0.18em",
          fontWeight: 600,
          marginBottom: 6,
          textTransform: "uppercase",
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontFamily: FONT_MONO,
          fontSize: 24,
          color: accent,
          fontWeight: 600,
          letterSpacing: "-0.02em",
          lineHeight: 1,
        }}
      >
        {value}
        {suffix && <span style={{ marginLeft: 4 }}>{suffix}</span>}
      </div>
    </div>
  );
}
